import z from "zod";

/** What the cabinet knows about the signed-in principal. */
export const SessionSchema = z.strictObject({
    principalId: z.string(),
    title: z.string(),
    roles: z.array(z.number()),
    resources: z.array(z.string()),
    expiresAt: z.number(),
});

export const CredentialsSchema = z.strictObject({
    email: z.email(),
    password: z.string().min(1),
});

export type Session = z.output<typeof SessionSchema>;
